import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/misc-purchase-order/{id}/submit`。body 僅 updatedAt。 */
export async function submitMiscPurchaseOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/srm/misc-purchase-order/${id}/submit`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
